export const TEST_ID = {
  shareButton: 'shareButton',
};

export const HOST = process.env.REACT_APP_HOST as string;
